// Section Shopify Shopify.theme editor events

$(document)
.on('shopify:section:reorder', function(e){

  var $target = $(e.target);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);

  if (Shopify.theme.jsHeader.enable_overlay == true) {
    Shopify.theme.jsHeader.unload();
    Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
  }

});

$(document)
.on('shopify:section:load', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Blocks within section
  var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

  var sectionObjectUrl = $section.find('[data-theme-editor-load-script]').attr('src');

  // Check classes on schema and look for js (eg. jsMap)
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js"){
      var triggerClass = section.classList[i];

      // Check to see if section script exists
      if (typeof Shopify.theme[triggerClass] == 'undefined') {
        // make AJAX call to load script
        Shopify.theme.loadScript(triggerClass, sectionObjectUrl, function () {
          Shopify.theme[triggerClass].init($(section));
        });
      } else {
        if (Shopify.theme[triggerClass]) {
          // console.log('Section: ' + triggerClass + ' has been loaded.')
          Shopify.theme[triggerClass].init($(section));
        } else {
          // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
        }
      }
    }
  }

  // Check classes on block element and look for js (eg. jsMap)
  if ($jsSectionBlocks.length > 0) {
    var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
      for (var i = 0; i < this.classList.length; i++) {
        if (this.classList[i].substring(0, 2) === "js") {
          var triggerClass = this.classList[i];
          var $block = $('.'+ triggerClass)
          var blockUrl = $block.find('[data-theme-editor-load-script]').attr('src');

          // Check to see if section script exists
          if (typeof Shopify.theme[triggerClass] == 'undefined') {
            // make AJAX call to load script
            Shopify.theme.loadScript(triggerClass, blockUrl, function () {
              Shopify.theme[triggerClass].init($block);
            });
          } else {
            if (Shopify.theme[triggerClass]) {
              // console.log('Block: ' + triggerClass + ' has been loaded.')
              Shopify.theme[triggerClass].init($(this));
            } else {
              // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
            }
          }

        }
      }
    });
  }

  // Load video feature
  Shopify.theme.video.init();

  // Scrolling animations
  Shopify.theme.animation.init();

  // Initialize reviews
  Shopify.theme.productReviews.init();

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

  // Infinite scrolling
  Shopify.theme.infiniteScroll.init();

  // Disclosure menus
  Shopify.theme.disclosure.enable();

  // Search
  $(document).on('click',  '[data-show-search-trigger]', function(){
    Shopify.theme.jsHeader.showSearch();
  });

  $('.search-overlay__close').on('click', function(){
    Shopify.theme.jsHeader.hideSearch();
  });

  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }
  // Product review scroll
  Shopify.theme.productReviews.productReviewScroll();

});


$(document)
.on('shopify:section:unload', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Blocks within section
  var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

  // Check classes on schema and look for js (eg. jsMap)
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js"){
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass]) {
        // console.log('Section: ' + triggerClass + ' is unloaded.')
        Shopify.theme[triggerClass].unload($(section));
      } else {
        // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.unload() function exists.');
      }
    }
  }

  // Check classes on block element and look for js (eg. jsMap)
  if ($jsSectionBlocks.length > 0) {
    var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
      for (var i = 0; i < this.classList.length; i++) {
        if (this.classList[i].substring(0, 2) === "js") {
          var triggerClass = this.classList[i];
          if (Shopify.theme[triggerClass]) {
            // console.log('Block: ' + triggerClass + ' is unloaded.')
            Shopify.theme[triggerClass].unload($(this));
          } else {
            // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.unload() function exists.');
          }

        }
      }
    });
  }

  // Scrolling animations
  Shopify.theme.animation.unload($section);

  // QuantityBox
  Shopify.theme.quantityBox.unload($section);

  // Infinite scrolling
  Shopify.theme.infiniteScroll.unload($section);

  // Disclosure menus
  Shopify.theme.disclosure.enable();

});

$(document)
.on('shopify:section:select', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Force show state when section is selected in theme editor
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass].showThemeEditorState) {
        Shopify.theme[triggerClass].showThemeEditorState(e.detail.sectionId, $section);
      }
    }
  }

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  if($('.tabs').length > 0) {
    Shopify.theme.tabs.enableTabs();
  }

  if(isScreenSizeLarge() && Shopify.theme.jsHeader.enable_overlay === true) {
    Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
  }

  if ($('.block__recommended-products').length > 0) {
    var $productPage = $('.block__recommended-products').parents('.product-page');
    Shopify.theme.jsRecommendedProducts.init($productPage);
  }

});

$(document)
.on('shopify:section:deselect', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Force hide state when section is selected in theme editor
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass].showThemeEditorState) {
        Shopify.theme[triggerClass].hideThemeEditorState(e.detail.sectionId, $(section));
      }
    }
  }

});

// Block Shopify Shopify.theme editor events

$(document)
.on('shopify:block:select', function(e){

  var blockId = e.detail.blockId;
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  var $block = $('#shopify-section-' + blockId);

  if($('.jsFeaturedPromos').length > 0) {
    Shopify.theme.jsFeaturedPromos.blockSelect($parentSection, blockId);
  }

  if($('.jsSlideshowWithText').length > 0) {
    Shopify.theme.jsSlideshowWithText.blockSelect($parentSection, blockId);
  }

  if ($('.jsSlideshowClassic').length > 0) {
    Shopify.theme.jsSlideshowClassic.blockSelect($parentSection, blockId);
  }

  if($('.jsTestimonials').length > 0) {
    Shopify.theme.jsTestimonials.blockSelect($parentSection, blockId);
  }

  // Sidebar collection multi-tag filter
  if ($block.hasClass('sidebar__block')) {
    var $toggleBtn = $block.find('[data-sidebar-block__toggle="closed"]');
    if ($toggleBtn) {
      Shopify.theme.jsSidebar.openSidebarBlock($toggleBtn);
    }
  }

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  // Scrolling animations
  Shopify.theme.animation.init();

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

});

$(document)
.on('shopify:block:deselect', function(e){

  var $block = $('#shopify-section-' + e.detail.blockId);

  if ($block.hasClass('sidebar__block')) {
    var $toggleBtn = $block.find('[data-sidebar-block__toggle="open"]');
    if ($toggleBtn) {
      Shopify.theme.jsSidebar.closeSidebarBlock($toggleBtn);
    }
  }

});

$(document)
.on('shopify:block:load', function(e){



});

// Document ready
$(function() {

  var $jsSections = $('.shopify-section[class*=js]');

  // Loop through sections with js classes and load them in
  var $jsSectionNames = $jsSections.each(function () {
    for (var i = 0; i < this.classList.length; i++) {
      if (this.classList[i].substring(0, 2) === "js"){
        var triggerClass = this.classList[i];
        if (Shopify.theme[triggerClass]) {
          // console.log('Section: ' + triggerClass + ' has been loaded.')
          Shopify.theme[triggerClass].init($(this));
        } else {
          // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
        }

      }
    }
  });

  var resizeTimer;

  // Store window width in variable
  var width = $(window).width(), height = $(window).height();

  $(window).on('resize', function(e) {

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {

      Shopify.theme.objectFitImages.calculateAspectRatio();

      if (Shopify.theme.jsHeader.header_layout === 'vertical') {
        Shopify.theme.predictiveSearch.alignVerticalSearch()
      }

      if (!isScreenSizeLarge()){
        // When 798 or less
        Shopify.theme.mobileMenu.init();

      } else {

        // When larger than 798
        Shopify.theme.mobileMenu.unload();

        // Swatches
        if(Shopify.theme_settings.product_form_style == 'swatches') {
          Shopify.theme.thumbnail.enableSwatches();
        }
      }

    }, 250);

  });

  //Enable plyr
  Shopify.theme.video.init();

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  Shopify.theme.dropdownMenu();

  Shopify.theme.disclosure.enable();

  // Scrolling animations
  Shopify.theme.animation.init();

  // QuantityBox
  Shopify.theme.quantityBox.init();

  /* Show secondary image on hover */
  if (Shopify.theme_settings.show_secondary_image == true) {
    Shopify.theme.thumbnail.showVariantImage();
  }

  // Collection swatches
  if (Shopify.theme_settings.show_collection_swatches) {
    Shopify.theme.thumbnail.enableSwatches();
  }

  // Quick shop
  if (Shopify.theme_settings.enable_quickshop) {
    Shopify.theme.thumbnail.showQuickShop();
  }

  // Currency converter
  if (Currency.show_multiple_currencies || Currency.native_multi_currency) {
    Shopify.theme.currencyConverter.init();
  }

  //Infinite scrolling
  if ($('[data-custom-pagination]').length) {
    Shopify.theme.infiniteScroll.init();
  }

  //Select event for native multi currency checkout
  $('.shopify-currency-form select').on('change', function () {
    $(this)
      .parents('form')
      .submit();
  });

  // Tabs
  if($('.tabs').length > 0) {
    Shopify.theme.tabs.enableTabs();
  }

  // Additional checkout buttons
  if (!isScreenSizeLarge()) {
    $('.additional-checkout-buttons').addClass('additional-checkout-buttons--vertical');
  }

  // Accordion
  if($('.accordion, [data-cc-accordion]').length > 0) {
    Shopify.contentCreator.accordion.init();
  }

  // Backwards compatiblity for Flexslider
  if($('.slider, .flexslider').length > 0) {
    Shopify.contentCreator.slideshow.init();
  }

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

  // Responsive Video
  Shopify.theme.responsiveVideo.init();

  // Flickity IOS Fix
  Shopify.theme.flickityIosFix();

  // Product review scroll
  Shopify.theme.productReviews.productReviewScroll();

});

/*============================================================================
Slideshow arrows
==============================================================================*/


if(Shopify.theme_settings.icon_style == 'icon_solid') {
  var arrowShape = 'M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z';
} else {
  var arrowShape = 'M95,48H9.83L41,16.86A2,2,0,0,0,38.14,14L3.59,48.58a1.79,1.79,0,0,0-.25.31,1.19,1.19,0,0,0-.09.15l-.1.2-.06.2a.84.84,0,0,0,0,.17,2,2,0,0,0,0,.78.84.84,0,0,0,0,.17l.06.2.1.2a1.19,1.19,0,0,0,.09.15,1.79,1.79,0,0,0,.25.31L38.14,86A2,2,0,0,0,41,86a2,2,0,0,0,0-2.83L9.83,52H95a2,2,0,0,0,0-4Z';
}

/* Blue badger JS */

$('.pdp-description .pdp-dc-title h2').on('click', function () {
  $('.pdp-description').toggleClass('__active');
});

$('.pdp-caracteristique .pdp-dc-title h2').on('click', function () {
  $('.pdp-caracteristique').toggleClass('__active');
});

$('.clp-products').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 5,
  prevArrow: '<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z" class="arrow"></path></svg></button>',
  nextArrow: '<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
  responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});

$('.products-slider-wrap').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 5,
  prevArrow: '<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z" class="arrow"></path></svg></button>',
  nextArrow: '<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
  responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});



$('.navp-departements').on('click', function() {
  if ($('.header__menu-departements').hasClass('hide')) {
    $('.header__menu-promotions').addClass('hide');
    $('.header__menu-departements').removeClass('hide')
  } else {
    $('.header__menu-promotions').addClass('hide');
    $('.header__menu-departements').addClass('hide');
  }
});

$('.navp-promotions').on('click', function() {
  if ($('.header__menu-promotions').hasClass('hide')) {
    $('.header__menu-departements').addClass('hide');
    $('.header__menu-promotions').removeClass('hide');
  } else {
    $('.header__menu-promotions').addClass('hide');
    $('.header__menu-departements').addClass('hide');
  }
});

$('.f-menu-wrap .mf-title').each(function (){
  $(this).on('click', function (){
    $(this).parent().toggleClass('open');
  });
});

$('body').on('click', '.mmb-departements', function() {
  $(this).parent().toggleClass('open');
});

$('body').on('click', '.mmb-promotion', function() {
  $(this).parent().toggleClass('open');
});

/*
$('.hm-wraper').on('click', '.h-votre-magasin', function() {
  $('.hm-wraper').toggleClass('open');
});
*/

$('.header-section').on('click', '.hvmp-changer', function() {
  $('.voir-les-magasins').toggleClass('open');
  $('.h-votre-magasin-popup').removeClass('open');
});
$('.mobile-header-locator').on('click', function() {
  $('.h-votre-magasin-popup').toggleClass('open');
});
$('.vlm-close').on('click', function() {
  $('.voir-les-magasins').removeClass('open');
});

$(".footer-go-up").click(function() {
  $("html, body").animate({ scrollTop: 0 }, "slow");
  return false;
});

window.addEventListener('scroll',()=>{
  var scrollY = document.documentElement.scrollTop;

  if (scrollY > 50) {
    $("body").addClass("nav-fixed");
  } else {
    $("body").removeClass("nav-fixed");
  }
});

$('.header__menu-departements').on('mouseleave', function () {
  $(this).addClass('hide');
});
$('.header__menu-promotions').on('mouseleave', function () {
  $(this).addClass('hide');
});

$('.plp-fd-title').on('click', function () {
  $(this).parent().toggleClass('open');
});

$('.pdp-d-button').on('click', function() {
  $(this).parent().toggleClass('active');
});

$('.mobile-search-tr').on('click', function() {
  $('body .boost-pfs-search-suggestion-mobile-top-panel').css('display', 'block');
});

$('.pdp-idb').on('click', function() {
  $('html, body').animate({
    scrollTop: $('.pdp-disponibilite').offset().top - 230
  }, 500);
});

$( document ).ready(function() {

  /* store selector */

  var is_fr = $('.vlm-all').attr('data-lang');
  is_fr = is_fr && is_fr === 'fr';

  var active_store = $('.vlm-all').attr('data-active-store');
  active_store = parseInt(active_store);

  if (active_store === 0) {
    jQuery.post('/cart/update.js', "attributes[store]=2");
  }

  setTimeout(function(){
    if(!is_fr) {
      $('.boost-pfs-filter-option-title-heading .boost-pfs-filter-option-title-text').each(function() {
        switch($(this).text()) {
          case 'Marques': $(this).text('Brands'); break;
          case 'Prix': $(this).text('Price'); break;
          case 'Promos': $(this).text('Promos'); break;
        }
      });
      $('.boost-pfs-filter-tree-mobile-sticky .boost-pfs-filter-option-title').on('click', function(){
        var text_title = $('.boost-pfs-filter-mobile-toolbar-middle').text();
        switch(text_title) {
          case 'Marques': $('.boost-pfs-filter-mobile-toolbar-middle').text('Brands'); break;
          case 'Prix': $('.boost-pfs-filter-mobile-toolbar-middle').text('Price'); break;
          case 'Promos': $('.boost-pfs-filter-mobile-toolbar-middle').text('Promos'); break;
        }
      });
    }
  }, 1000);


  function getActiveHour (all_hours) {
    var json_hours = JSON.parse(all_hours);
    var d = new Date();
    var n = d.getDay();
    var to_day = 'MON';
    switch(n) {
      case 1: to_day = 'MON'; break;
      case 2: to_day = 'TUE'; break;
      case 3: to_day = 'WED'; break;
      case 4: to_day = 'THU'; break;
      case 5: to_day = 'FRI'; break;
      case 6: to_day = 'SAT'; break;
      case 0: to_day = 'SUN'; break;
    }
    var active_hour = json_hours.filter(d => d.day === to_day)[0];
    return active_hour;
  }

  function getHeureToday(all_hours) {
    var active_hour = getActiveHour(all_hours);

    var html = '';
    if (active_hour.is_closed) {
      if (is_fr) {
        html = '<span>Fermé</span>';
      } else {
        html = '<span>Closed</span>';
      }
    } else {
      if (is_fr) {
        html = '<span>Heures:</span>'+
                active_hour.from_hour.substring(0, 2) +':'+ active_hour.from_hour.substring(2) +' à ' +
                active_hour.to_hour.substring(0, 2) +':'+ active_hour.to_hour.substring(2);
      } else {
        html = '<span>Hours:</span>' +
                active_hour.from_hour.substring(0, 2) +':'+ active_hour.from_hour.substring(2) +' to ' +
                active_hour.to_hour.substring(0, 2) +':'+ active_hour.to_hour.substring(2);
      }
    }
    return html;
  }

  function renderActiveMagasin(stores) {
    var html = '';
    var as = active_store === 0 ? 2 : active_store;
    var as_o_ = stores.filter(stor => stor.code === as)[0];
    var as_o = getActiveHour(as_o_.opening_hours);

    if (is_fr) {
      html = '<button class="h-votre-magasin">Votre magasin:<br><span>'+ as_o_.city +' - ' +
              as_o.from_hour.substring(0, 2) +':'+ as_o.from_hour.substring(2) +' à ' +
              as_o.to_hour.substring(0, 2) +':'+ as_o.to_hour.substring(2) +
              '</span></button>';
    } else {
      html = '<button class="h-votre-magasin">Your store:<br><span>'+ as_o_.city +' - ' +
              as_o.from_hour.substring(0, 2) +':'+ as_o.from_hour.substring(2) +' to ' +
              as_o.to_hour.substring(0, 2) +':'+ as_o.to_hour.substring(2) +
              '</span></button>';
    }

    $('.h-magasin-selected').html(html).attr('data-active-store', as);

    var html_ = '';
    var label_direction = is_fr?'Obtenez les directions': 'Get directions';
    var label_heures = is_fr?'Heures:': 'Hours:';
    var label_tel = is_fr?'Téléphone:': 'Telephone:';
    var label_free = is_fr?'Sans frais:': 'Call free:';
    var label_changer = is_fr?'Changer de magasin': 'Change store';
    var url_direction = as_o_.url_direction ? as_o_.url_direction : '#';
    var heur_ = '';
    if (is_fr) {
      heur_ = as_o.from_hour.substring(0, 2) +':'+ as_o.from_hour.substring(2) +' à ' +
              as_o.to_hour.substring(0, 2) +':'+ as_o.to_hour.substring(2);
    } else {
      heur_ = as_o.from_hour.substring(0, 2) +':'+ as_o.from_hour.substring(2) +' to ' +
              as_o.to_hour.substring(0, 2) +':'+ as_o.to_hour.substring(2);
    }

    html_ = '<div class="hvmp-title">'+ as_o_.name +'</div>' +
            '<div class="hvmp-addres">'+ as_o_.address +', '+ as_o_.city +', '+ as_o_.province +' '+ as_o_.zip +'</div>' +
            '<a class="hvmp-direction" href="'+ url_direction +'">'+ label_direction +'</a>' +
            '<div class="hvmp-heures"><span>'+ label_heures +'</span>'+ heur_ +'</div>' +
            '<div class="hvmp-tel"><span>'+ label_tel +'</span>'+ as_o_.phone +'</div>' +
            '<div class="hvmp-tel2"><span>'+ label_free +'</span>'+ as_o_.freenum +'</div>' +
            '<button class="hvmp-changer btn">'+ label_changer +'</button>';

    $('.h-votre-magasin-popup').html(html_);

  }

  function pageGetHours(json_hours) {
    var htmlh = '';
    json_hours.map(js => {
      var label_h = '';
      var label_a = (is_fr) ? ' à ' : ' to ';
      var label_close = (is_fr) ? ' Fermé' : ' Close';
      switch(js.day) {
        case 'MON': label_h = (is_fr) ? 'Lundi : ' : 'Monday : '; break;
        case 'TUE': label_h = (is_fr) ? 'Mardi : ' : 'Tuesday : '; break;
        case 'WED': label_h = (is_fr) ? 'Mercredi : ' : 'Wednesday : '; break;
        case 'THU': label_h = (is_fr) ? 'Jeudi : ' : 'Thursday : '; break;
        case 'FRI': label_h = (is_fr) ? 'Vendredi : ' : 'Friday : '; break;
        case 'SAT': label_h = (is_fr) ? 'Samedi : ' : 'Saturday : '; break;
        case 'SUN': label_h = (is_fr) ? 'Dimanche : ' : 'Sunday : '; break;
      };

      if (js.is_closed) {
        htmlh += '<p>'+ label_h + label_close +'</p>';
      } else {
        htmlh += '<p>'+ label_h +' '+ js.from_hour.substring(0, 2)+':'+ js.from_hour.substring(2) + label_a +
                js.to_hour.substring(0, 2)+':'+ js.to_hour.substring(2) +'</p>';
      }

    });
    return htmlh;
  }

  function renderUnePageStore(store_page_active, i) {
    var html = '';
    var json_hours = JSON.parse(store_page_active.opening_hours);
    var page_get_hours = pageGetHours(json_hours);
    var label_tel = (is_fr) ? ' Tel : ' : ' Phone : ';
    var label_sans_f = (is_fr) ? ' Sans frais : ' : ' No fees : ';
    var label_fax = (is_fr) ? ' Téléc : ' : ' Fax : ';
    var label_direction = (is_fr) ? ' Obtenez la direction ' : ' Get route ';
    var label_store_h = (is_fr) ? "HEURES D'OUVERTURE" : "OPENING HOURS";
    var label_store_info = (is_fr) ? '*Du lundi au vendredi ouverture dès 7h pour les entrepreneurs.' : '* Monday to Friday open from 7 a.m. for entrepreneurs.';

    html = '<div class="nouj-block-left"> ' +
            '<h1>'+ store_page_active.name +'</h1> ' +
            '<p>'+ store_page_active.address+','+'<br/>'+ store_page_active.province + ' ' + store_page_active.zip + '</p> ' +
            '<p>'+ label_tel + '<a href="tel:store_page_active.phone">' + store_page_active.phone + '</a>' +
            '<br />' + label_sans_f + '<a href="store_page_active.freenum">'+ store_page_active.freenum +'</a> ' +
            '<br />'+ label_fax + '<a href="store_page_active.fax">'+ store_page_active.fax +'</p> ' +
            '<p>'+'<a href="mailto:'+ store_page_active.mail +'">'+ store_page_active.mail + '</a></p> ' +
            '<p class="directions-link">'+ '<a href="'+ store_page_active.url_direction +'">'+ label_direction +'</a></p> ' +
            '</div> ' +
            '<div class="nouj-block-right"> ' +
            '<h4>'+ label_store_h +'</h4> ' +
                    page_get_hours +
            '<p>'+ label_store_info +'</p> ' +
            '</div>';

    $('.nouj-block').eq(i).html(html);
  }

  function renderPageContact(stores) {
    var is_contact_page = $('.page--contact').length > 0;
    if (is_contact_page) {
      stores.map((st, index)=> renderUnePageStore(st, index));
    }
  }

  function renderPageStore(stores) {
    var is_magasin = $('.page--magasin').length > 0;
    if (is_magasin) {
      var store_page = $('.page--magasin').attr('data-page-store');
      var store_page_active = stores.filter(st => st.code == store_page)[0];

      renderUnePageStore(store_page_active, 0);

    }
  }

  function renderMagasins(stores) {

    if (stores && stores.length > 0) {

      $('#all-magazins-json').html(JSON.stringify(stores));

      renderActiveMagasin(stores);

      var html = '';
      stores.map(stor => {
        var heure_today = getHeureToday(stor.opening_hours);
        var label_a = is_fr?'Voir les détails du magasin': 'View Store Details';
        var label_button = is_fr?'Choisir ce magasin': 'Choose this store';
        var url_link = '#';
        if (is_fr && stor.urlpage_fr)  { url_link = stor.urlpage_fr };
        if (!is_fr && stor.urlpage_en) { url_link = stor.urlpage_en };

        html += '<div class="vlm-magasin">' +
                '<div class="vlm-title">'+ stor.name +'</div>' +
                '<div class="vlm-address">'+ stor.address +', '+ stor.city +', '+ stor.province + ' '+ stor.zip +'</div>' +
                '<div class="vlm-heures">'+ heure_today +'</div>' +
                '<a class="vlm-voir" href="'+ url_link +'">'+ label_a +'</a>' +
                '<button class="btn vlm-btn set-store-active" data-set-store="'+ stor.code +'">'+ label_button +'</button>' +
                '</div>';
      });

      $('.vlm-all').html(html);

      renderPageStore(stores);
      renderPageContact(stores);

    }
  }

  function getAjaxStores(url_) {
    $.ajax({
      url: url_,
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*"
      },
      success: (response) => {
        if (response.code == 200) renderMagasins(response.data.stores)
      }
    });
  }

  function showPosition(position) {
    var ll = position.coords.latitude+"/"+position.coords.longitude+"/";
    var url_store_locator = '/apps/store-locator/stores/' + ll;
    getAjaxStores(url_store_locator);
  }

  function showError(error) {
    switch(error.code) {
      case error.PERMISSION_DENIED:
        getAjaxStores('/apps/store-locator/stores/');
        break;
      case error.POSITION_UNAVAILABLE:
        getAjaxStores('/apps/store-locator/stores/');
        break;
      case error.TIMEOUT:
        getAjaxStores('/apps/store-locator/stores/');
        break;
      case error.UNKNOWN_ERROR:
        getAjaxStores('/apps/store-locator/stores/');
        break;
    }
  }

  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, showError);
    } else {
      getAjaxStores('/apps/store-locator/stores/');
    }
  }

 // getLocation();
/*
  $('body').on('click', '.set-store-active', function () {
    var code_store = $(this).attr('data-set-store');
        code_store = parseInt(code_store)
    if (code_store) {
      jQuery.post('/cart/update.js', 'attributes[store]='+ code_store)
        .done(function() { location.reload() });
    }
  });
*/
  /* end store selector */
/*
  $.ajax({
    url: "https://gyg.malcommiddleware.com/storage/categories.json",
    method: "GET",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "text/plain"
    },
    success: (response) => {
      menuAtimatique(response);
    }
  });
*/
  function parentActive2(pa2, ah, pa1_handle) {
    var return_ = '';
    if (pa2) {
      pa2.map(ma2 => {
        if (ma2.url_handle === ah || pa1_handle === ah) return_ = 'open';
      });
    }
    return return_;
  }

  function parentActive1(pa1, ah) {
    var return_ = '';
    pa1.map(ma1 => {
      if (ma1.url_handle === ah) return_ = 'open';
      if (parentActive2(ma1.children, ah) === 'open') return_ = 'open';
    });
    return return_;
  }

  function menuAtimatique (mj) {
    var active_handle = window.location.pathname;
        active_handle = active_handle.replace('/collections/', '');

    if (mj) {
      var html = '';
      var htmlm = '';
      var htmlp = '';
      var htmlpm = '';
      var lang = $('.insert-js-menu').attr('data-lang');
      var img_promo = $('.insert-js-menu').attr('data-img-promo');
      lang += '_CA';
      var en = lang === 'en_CA' ? '/en' : ''

      var label_promo = lang === 'fr_CA' ? 'Promos' : 'Promos';
      var label_promo_m = lang === 'fr_CA' ? 'Tout Promos' : 'All Promos';
      htmlp += '<div class="navbar-item header__item has-dropdown has-dropdown--horizontal is-hoverable" aria-haspopup="true" aria-expanded="false" data-navlink-handle="/promo">'
              + '<a class="navbar-link header__link" href="'+ en +'/collections/promo">'
                + label_promo
                + '<span class="m-icon-procent"><img src="'+ img_promo +'" alt="Icon Promo"></span>'
              + '</a>'

              + '<div class="navbar-dropdown navbar-dropdown--below-header is-horizontal has-medium-vertical-spacing">'
                + '<div class="nav-down">';

      htmlpm += '<li class="mobile-menu__list-item" data-mobile-menu-navlink-handle="promos"> ' +
                  '<div class="mobile-menu__first-level has-submenu" data-mobile-menu-has-toggle="true"> ' +
                    '<input class="visuallyhidden submenu__input" type="checkbox" id="mobile-submenu-1">' +
                    '<label class="submenu__label" for="mobile-submenu-1">' +
                      '<a href="'+ en +'/collections/promo" class="mobile-menu-link ">' +
                        label_promo +
                      '</a> <span class="close-dropdown"></span>' +
                    '</label>' +
                    '<ul class="mobile-submenu__list mobile-menu__submenu has-dropdown" data-mobile-submenu-first-level-list="">' +
                      '<li class="mobile-menu__submenu-list-item">' +
                        '<a href="'+ en +'/collections/promo" class="mobile-menu__item">' +
                          label_promo_m +
                        '</a>' +
                      '</li>';

      mj[0].children.map(m1 => {
        htmlp += '<div class="horizontal-dropdown__column">'
                + '<a class="nav-item-1" href="'+ en +'/search?pf_c_departements='+ m1.relation_identifier +'&pf_mlt_promos=filter_type%3Acirculaire&pf_mlt_promos=filter_type%3Aliquidation&pf_mlt_promos=filter_type%3Apromotion">'+ m1.category_title[lang] + '</a>'
              + '</div>';

        htmlpm += '<li class="mobile-menu__submenu-list-item">' +
                    '<a href="'+ en +'/search?pf_c_departements='+ m1.relation_identifier +'&pf_mlt_promos=filter_type%3Acirculaire&pf_mlt_promos=filter_type%3Aliquidation&pf_mlt_promos=filter_type%3Apromotion" class="mobile-menu__item">' +
                        m1.category_title[lang] +
                    '</a>' +
                  '</li>'
      });

      htmlp += '</div> </div> </div>';

      htmlpm += '</ul> </div> </li>';

      html += htmlp;
      htmlm += htmlpm;

      mj[0].children.map((m1, index1) => {
        htmlm += '<li class="mobile-menu__list-item" data-mobile-menu-navlink-handle="'+ m1.url_handle +'">';
        var active1 = m1.url_handle === active_handle ? 'active' : '';

        if (!m1.children) {
          html += '<div class="navbar-item header__item" data-navlink-handle="'+ m1.url_handle +'">';
            html += '<a href="'+ en +'/collections/'+ m1.url_handle +'" class="navbar-link header__link is-arrowless">';
            html  += m1.category_title[lang];
            html += '</a>';
          html += '</div>';

          htmlm += '<div class="mobile-menu__first-level has-no-submenu" data-mobile-menu-has-toggle="false">'
                  + '<input class="visuallyhidden submenu__input" type="checkbox" id="mobile-submenu-'+ m1.category_title[lang] +'">'
                  + '<label class="submenu__label" for="mobile-submenu-'+ m1.category_title[lang] +'">'
                    + '<a class="mobile-menu__item '+ active1 +'" href="'+ en +'/collections/'+ m1.url_handle +'">'
                      + m1.category_title[lang]
                    + '</a>'
                  + '</label>'
                  + '</div>'
        } else {
          var parent_active1 = parentActive1(m1.children, active_handle);
          html += '<div class="navbar-item header__item has-dropdown has-dropdown--horizontal is-hoverable" aria-haspopup="true" aria-expanded="false" data-navlink-handle="'+ m1.url_handle +'">'
                  + '<a class="navbar-link header__link" href="'+ en +'/collections/'+ m1.url_handle +'">'
                  + m1.category_title[lang]
                  + '</a>'

                  + '<div class="navbar-dropdown navbar-dropdown--below-header is-horizontal has-medium-vertical-spacing">'
                  + '<div class="nav-down">';

          var current_index1 = index1;
          var label_all = lang === 'fr_CA' ? 'Tout' : 'All'
          htmlm += '<div class="mobile-menu__first-level has-submenu '+ parent_active1 +'" data-mobile-menu-has-toggle="true">'
                  + '<input class="visuallyhidden submenu__input" type="checkbox" id="mobile-submenu-'+ index1 +'">'
                  + '<label class="submenu__label" for="mobile-submenu-'+ index1 +'">'
                  + '<a class="mobile-menu-link" href="'+ en +'/collections/'+ m1.url_handle +'">'
                  + m1.category_title[lang]
                  + '</a>'
                  + '<span class="close-dropdown"></span>'
                  + '</label>'
                  + '<ul class="mobile-submenu__list mobile-menu__submenu has-dropdown" data-mobile-submenu-first-level-list>'
                  + '<li class="mobile-menu__submenu-list-item">'
                  + '<a class="mobile-menu__item '+ active1 +'" href="'+ en +'/collections/'+ m1.url_handle +'">'
                  + label_all +'&nbsp;'+ m1.category_title[lang]
                  + '</a>'
                  + '</li>'

          m1.children.map((m2, index2) => {
            htmlm += '<li class="mobile-menu__submenu-list-item">';
            var active2 = m2.url_handle === active_handle ? 'active' : '';
            if (!m2.children) {
              html += '<div class="horizontal-dropdown__column">'
                      + '<a class="nav-item-1" href="'+ en +'/collections/'+ m2.url_handle +'">'
                      + m2.category_title[lang]
                      + '</a>'
                      + '</div>';

              htmlm += '<a class="mobile-menu__item '+ active2 +'" href="'+ en +'/collections/'+ m2.url_handle +'">'+ m2.category_title[lang] +'</a>';
            } else {
              var parent_active2 = parentActive2(m2.children, active_handle, m2.url_handle);

              html += '<div class="horizontal-dropdown__column has-submenu">'
                      + '<a href="'+ en +'/collections/'+ m2.url_handle +'" class="nav-item-1">'
                      + m2.category_title[lang]
                      + '</a>'
                      + '<ul class="navbar-submenu is-visible">';

              htmlm += '<div class="mobile-menu__second-level '+ parent_active2 +'">'
                      + '<input class="visuallyhidden submenu__input" type="checkbox" id="mobile-sub-submenu-'+ index2 +'-'+ current_index1 +'">'
                      + '<label class="submenu__label" for="mobile-sub-submenu-'+ index2 +'-'+ current_index1 +'">'
                      + '<a class="mobile-menu-link" <a href="'+ en +'/collections/'+ m2.url_handle +'">'
                      + m2.category_title[lang]
                      + '</a>'
                      + '<span class="close-sub-dropdown"></span>'
                      + '</label>'

                      + '<ul class="mobile-sub-submenu__list mobile-menu__submenu" data-mobile-submenu-second-level-list>'
                      + '<li class="mobile-menu__submenu-list-item">'
                      + '<a class="mobile-menu__item '+ active2 +'" <a href="'+ en +'/collections/'+ m2.url_handle +'">'
                      + label_all +'&nbsp;'+ m2.category_title[lang]
                      + '</a>'
                      + '</li>';

              m2.children.map(m3 => {
                var active3 = m3.url_handle === active_handle ? 'active' : '';
                html += '<li>'
                        + '<a class="nav-item-2" href="'+ en +'/collections/'+ m3.url_handle +'">'
                        + m3.category_title[lang]
                        + '</a>'
                        + '</li>';

                htmlm += '<li class="mobile-menu__submenu-list-item">'
                        + '<a class="mobile-menu__item '+ active3 +'" href="'+ en +'/collections/'+ m3.url_handle +'">'+ m3.category_title[lang] +'</a>'
                        + '</li>';
              });
              html += '</ul>'
                      + '</div>';

              htmlm += '</ul>'
                      + '</div>';
            };
            htmlm += '</li>'
          });
          html += '</div>'
                  + '</div>'
                  + '</div>';

          htmlm += '<ul>'
                  + '</div>';
        };
        htmlm += '</li>';
      })

      $('.insert-js-menu').html(html);
      $('.insert-js-menu-mobile').html(htmlm);
      $('.insert-js-plp-menu-mobile').html(htmlm);
    }
  }

  $('.plp-filter-departements').on('click', '.mobile-menu__first-level>label', function() {
    var temp_click = $(this).parent();
    var is_open = temp_click.hasClass('open');
    $('.plp-filter-departements .mobile-menu__first-level').removeClass('open');
    $('.plp-filter-departements .mobile-menu__second-level').removeClass('open');
    if (is_open) { temp_click.removeClass('open')} else {temp_click.addClass('open')};
  });

  $('.plp-filter-departements').on('click', '.mobile-menu__second-level>label', function() {
    var temp_click = $(this).parent();
    var is_open = temp_click.hasClass('open');
    $('.plp-filter-departements .mobile-menu__second-level').removeClass('open');
    if (is_open) { temp_click.removeClass('open')} else {temp_click.addClass('open')};
  });



  var _sityVal = $('#widget-ji-search__cityInputTrueValue');
  var _latVal = $('#widget-ji-search__cityInputfLat');
  var _lngVal = $('#widget-ji-search__cityInputfLng');
  var _container = $('#jobillico-widget-box');
  var _action = $('#widget-ji-search');
  var lang = $('.insert-js-menu').attr('data-lang');

  if(_container && _sityVal && _latVal && _lngVal && _action) {
    var _v = lang == 'fr' ? 'Ville' : 'City';
    var _select = $('<select/>')
            .addClass('nf-custom-select')
            .attr('data-selected', 0)
        .html('<option value="0">' + _v + '</option>' +
                '<option value="6105">Saint-Jean-sur-Richelieu</option>' +
                '<option value="5899">Mont-Tremblant</option>' +
                '<option value="5917">Saint-Jérôme</option>' +
                '<option value="6283">Saint-André-Avellin</option>' +
                '<option value="6243">Cheneville</option>' +
                '<option value="5204">Amqui</option>')
            .on('change', function(){
              var _val = $(this).val();
              $(this).attr('data-selected', _val);
              window.__Jobillico__.arrWidgetDataTemp.scty = _val;
              initWidget(1);
            })
        .prependTo(_container);
  }

  setTimeout(function (){
    if (window.Shopify.locale === "en") {
      $('.cc-message .cc-link').attr('href', 'https://materiauxjls.ca/en/pages/en-conditions_dutilisation');
      $('.cc-window.cc-banner').addClass('view');
    }
  }, 2000);
});
/* end Blue badger JS */



